import styled from '@emotion/styled'
import {css} from '@emotion/react'
import {theme} from '../../../../../../core/theme'

// ─── Wrapper ──────────────────────────────────────────────────────────────────
// Full-width bar with a bottom border that the active tab indicator overlaps.

export const TabGroupWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0;
  // width: 100%;
  // border-bottom: 1.5px solid ${theme.colors.border.default};
  // font-family: ${theme.fonts.body};
  background: transparent;
`

// ─── Tab list ────────────────────────────────────────────────────────────────

export const TabList = styled.div`
  display: flex;
  align-items: flex-end;
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

// ─── Individual Tab ───────────────────────────────────────────────────────────

export const Tab = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: ${theme.space[3]};
  padding: ${theme.space[2.5]} ${theme.space[5]};
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  flex-shrink: 0;
  background: ${({active}) =>
    active
      ? 'linear-gradient(180deg, rgba(255, 255, 255, 0) 12.5%, #FFE6DA 100%)'
      : 'transparent'};

  /* Active indicator — 2px blue line that sits ON the wrapper border */
  &::after {
    content: '';
    position: absolute;
    bottom: -1.5px; /* overlap the wrapper border */
    left: 0;
    right: 0;
    height: 4px;
    background: transparent;
    transition: background ${theme.transitions.normal};
  }

  ${({active}) =>
    active &&
    css`
      &::after {
        background: ${theme.palette.thryv.orange.base};
      }
    `}
`

// ─── Tab label (plain or input) ───────────────────────────────────────────────

export const TabLabel = styled.span`
  font-size: ${theme.fontSizes.base};
  font-weight: ${({active}) =>
    active ? theme.fontWeights.bold : theme.fontWeights.regular};
  color: ${({active}) =>
    active ? theme.colors.text.primary : theme.colors.text.primary};
  transition: color ${theme.transitions.fast},
    font-weight ${theme.transitions.fast};
  min-width: 20px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const TabInput = styled.input`
  font-family: ${theme.fonts.body};
  font-size: ${theme.fontSizes.base};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
  border: none;
  border-bottom: 1.5px solid ${theme.colors.border.focus};
  outline: none;
  background: transparent;
  padding: 0;
  min-width: 20px;
  width: ${({inputWidth}) => inputWidth || '60px'};
`
export const CharCount = styled.span`
  font-size: 10px;
  line-height: 1;
  white-space: nowrap;
  flex-shrink: 0;
  color: ${({warn}) => (warn ? '#ef4444' : '#9ca3af')};
  transition: color 0.15s ease;
`

export const ActionButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.space[1]};
`

// // ─── Icon action buttons inside each tab ─────────────────────────────────────

// export const TabIconButton = styled.button`
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   width: 22px;
//   height: 22px;
//   padding: 0;
//   border: none;
//   background: transparent;
//   cursor: pointer;
//   border-radius: ${theme.radii.sm};
//   color: ${theme.colors.text.muted};
//   transition: color ${theme.transitions.fast},
//     background ${theme.transitions.fast};
//   flex-shrink: 0;

//   &:hover {
//     color: ${theme.colors.text.primary};
//     background: ${theme.colors.bg.tertiary};
//   }

//   &:focus-visible {
//     outline: 2px solid ${theme.colors.border.focus};
//     outline-offset: 1px;
//   }

//   svg {
//     width: 13px;
//     height: 13px;
//     stroke-width: 1.75;
//   }
// `

// // ─── "Add Proposal" button ────────────────────────────────────────────────────

// export const AddTabButton = styled.button`
//   display: inline-flex;
//   align-items: center;
//   gap: ${theme.space[1.5]};
//   padding: ${theme.space[1.5]} ${theme.space[3]};
//   margin-left: ${theme.space[2]};
//   margin-bottom: ${theme.space[1.5]};
//   font-family: ${theme.fonts.body};
//   font-size: ${theme.fontSizes.base};
//   font-weight: ${theme.fontWeights.medium};
//   color: ${theme.colors.text.primary};
//   background: ${theme.colors.bg.primary};
//   border: 1.5px solid ${theme.colors.border.strong};
//   border-radius: ${theme.radii.full};
//   cursor: pointer;
//   white-space: nowrap;
//   flex-shrink: 0;
//   transition: background ${theme.transitions.fast},
//     border-color ${theme.transitions.fast}, color ${theme.transitions.fast};

//   &:hover {
//     background: ${theme.colors.bg.tertiary};
//     border-color: ${theme.colors.border.dark};
//   }

//   &:focus-visible {
//     outline: 2px solid ${theme.colors.border.focus};
//     outline-offset: 2px;
//   }

//   svg {
//     width: 16px;
//     height: 16px;
//     flex-shrink: 0;
//   }
// `
